declare namespace $ {

	type $mol_view__sub_bog_worm_detail_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_detail_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_worm_detail_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_worm_detail_4 = $mol_type_enforce<
		ReturnType< $bog_worm_detail['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_worm_detail_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_worm_detail_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_worm_detail_7 = $mol_type_enforce<
		ReturnType< $bog_worm_detail['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_worm_detail_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_detail_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_detail_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_detail_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_worm_detail_12 = $mol_type_enforce<
		ReturnType< $bog_worm_detail['row_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_worm_detail_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_worm_detail extends $mol_view {
		name( ): string
		Name( ): $mol_view
		facts( ): string
		Facts( ): $mol_view
		close( next?: any ): any
		close_label( ): string
		Close( ): $mol_button_minor
		Head( ): $mol_view
		rows( ): readonly(any)[]
		List( ): $mol_list
		section_title( id: any): string
		row_click( id: any, next?: any ): any
		row_peer( id: any): string
		Row_peer( id: any): $mol_view
		row_note( id: any): string
		Row_note( id: any): $mol_view
		row_weight( id: any): string
		Row_weight( id: any): $mol_view
		focus( next?: string ): string
		sub( ): readonly(any)[]
		Section( id: any): $mol_view
		Row( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=detail.view.tree.d.ts.map